import { render, staticRenderFns } from "./DocumentsForSigning.vue?vue&type=template&id=8c446dba&scoped=true&"
import script from "./DocumentsForSigning.vue?vue&type=script&lang=js&"
export * from "./DocumentsForSigning.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsForSigning.vue?vue&type=style&index=0&id=8c446dba&prod&lang=css&"
import style1 from "./DocumentsForSigning.vue?vue&type=style&index=1&id=8c446dba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c446dba",
  null
  
)

export default component.exports